<template>
	<div class="flex gap-5 py-2 flex-row items-center odd:bg-white even:bg-sky-50 px-5 justify-between">
		<div class="flex items-center cursor-pointer gap-2">
			<div class="text-blue-400"><i class="fa-regular fa-hospital"></i></div>
			<div>
				<p @click.prevent="router.visit(route('structures.get', { structure: structure.id }))" class="font-medium">
					{{ structure.name }}
				</p>
				<div v-if="!displayEditModal" @click.prevent="router.visit(route('structures.get', { structure: structure.id }))">
					<p v-if="structure.pivot?.status_id" class="text-sm text-gray-500">
						{{ page.props.str.statuses.find((element) => element.id == structure.pivot.status_id)?.name }}
					</p>
					<p v-if="structure.pivot?.service_id" class="text-sm text-gray-500">
						{{ page.props.str.statuses.find((element) => element.id == structure.pivot.service_id)?.name }}
					</p>
				</div>
				<div v-else class="flex gap-2">
					<form-select
						:items="page.props.str.statuses.filter((element) => element.type == 'skill')"
						prefix="Statut : "
						placeholder="Statut"
						@valueChange="form.status = $event"
						:value="form.status"
						class="lg:col-span-1 col-span-2">
						<template v-slot:icon>
							<i class="fas fa-fw fa-caret-down"></i>
						</template>
					</form-select>
					<form-select
						:items="page.props.str.statuses.filter((element) => element.type == 'service')"
						prefix="Services : "
						placeholder="Service"
						@valueChange="form.service = $event"
						:value="form.service"
						class="lg:col-span-1 col-span-2">
						<template v-slot:icon>
							<i class="fas fa-fw fa-caret-down"></i>
						</template>
					</form-select>
				</div>
			</div>
		</div>
		<div class="flex flex-row items-center gap-5">
			<div @click="handleUpdate" class="text-slate-500 hover:text-slate-700 cursor-pointer">
				<i v-if="displayEditModal" class="fas fa-check"></i>
			</div>
			<div @click="toggleEditModal" class="text-slate-500 hover:text-slate-700 cursor-pointer">
				<i v-if="!displayEditModal" class="fas fa-edit"></i>
				<i v-else class="fas fa-cancel"></i>
			</div>
			<div @click="handleDelete" class="text-slate-500 hover:text-slate-700 cursor-pointer">
				<i class="fas fa-trash"></i>
			</div>
		</div>
	</div>
</template>

<script setup>
	import { ref } from 'vue';
	import { usePage, router } from '@inertiajs/vue3';

	const page = usePage();

	const props = defineProps({
		structure: {
			type: Object,
			required: true,
			default: () => ({}),
		},
	});

	const emit = defineEmits(['delete', 'update']);

	const displayEditModal = ref(false);

	const form = ref({
		status: props.structure.pivot?.status_id || null,
		service: props.structure.pivot?.service_id || null,
		target: props.structure.id,
		id: props.structure.pivot?.id || null,
	});

	const toggleEditModal = () => {
		displayEditModal.value = !displayEditModal.value;
	};

	const handleUpdate = () => {
		emit('update', form.value);
		toggleEditModal();
	};

	const handleDelete = () => {
		emit('delete', form.value.id);
	};
</script>
